import { useEffect, useRef } from "react";
import { Outlet, useLocation, useParams, Navigate } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CookieConsent from "./CookieConsent";
import { Toaster } from "./ui/sonner";
import { trackPageView } from "../lib/analytics";

export default function Layout() {
  const { lang } = useParams();
  const location = useLocation();
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    lenisRef.current?.scrollTo(0, { immediate: true });
    trackPageView(location.pathname, document.title, lang);
  }, [location.pathname]);

  if (lang !== "en" && lang !== "it") {
    return <Navigate to={`/en${location.pathname === "/" ? "" : location.pathname}`} replace />;
  }

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar lang={lang} />
      <main className="flex-1">
        <Outlet context={{ lang }} />
      </main>
      <Footer lang={lang} />
      <CookieConsent lang={lang} />
      <Toaster position="top-center" richColors />
    </div>
  );
}
